<style lang="less" scoped>

</style>

<template>
    <div>
        <h2 class="pageTitle">產品分類管理</h2>

        <!-- 搜索Box -->
        <div class="sb searchBoxWrap">
            <div class="al">
                <Input type="text" v-model="keyword" clearable @on-clear="search" @on-keydown.enter="search" /> 
                <Button type="primary" class="searchBtn" @click="search">搜索</Button>
            </div>
            <div>
                <Button type="info" @click="showAdd=true">+ 創建新產品分類</Button>
            </div>
        </div>

        <div class="tableWrap">
            <Table :columns="columns" :data="list" :searchable="false" border :loading="tableLoad">
                <template slot="action" slot-scope="{row}">
                    <div class="ju">
                        <Button type="warning" size='small' style="margin-right: 10px;" @click="edit(row)">編輯</Button>
                        <Button type="error" size='small' @click="del(row)">刪除</Button>
                    </div>
                </template>
            </Table>
        </div>

        <div class="PageWrap">
            <Page :current="page" :page-size="offset" :total="total" @on-change="changePage"></Page>
        </div>

        <!-- 創建 -->
        <Modal v-model="showAdd">
            <div slot="header" class="ModalHeader">
                <div>創建新產品分類</div>
            </div>

            <div>
                <Form :model="addForm" :rules="rules" :label-width="130" ref="addForm">
                    <FormItem prop="name" label="產品分類名稱">
                        <Input v-model="addForm.name" style="width:250px" @on-keydown.enter="okAdd" />
                    </FormItem>
                </Form>
            </div>

            <div slot="footer" class="ju ModalBtn">
                <Button type="error" size="small" @click="showAdd=false">取消</Button>
                <Button type="info" size="small" @click="okAdd" :loading="load">+ 創建</Button>
            </div>
        </Modal>

        <!-- 編輯 -->
        <Modal v-model="showEdit">
            <div slot="header" class="ModalHeader">
                <div>創建產品分類</div>
            </div>

            <div>
                <Form :model="editForm" :rules="rules" :label-width="130" ref="editForm">
                    <FormItem prop="name" label="產品分類名稱">
                        <Input v-model="editForm.name" style="width:250px" @on-keydown.enter="okEdit" />
                    </FormItem>
                </Form>
            </div>

            <div slot="footer" class="ju ModalBtn">
                <Button type="error" size="small" @click="showEdit=false">取消</Button>
                <Button type="info" size="small" @click="okEdit" :loading="load">編輯</Button>
            </div>
        </Modal>
    </div>
</template>

<script>
export default {
    data () {
        return {
            columns: [
                { title: "編號", key: "id", sortable: true, align:"center", width: 100 },
                { title: "產品分類名稱", key: "name", sortable: true, align:"center" },
                { title: "創建時間", key: "createAt", sortable: true, align:"center" },
                { title: "操作", slot: "action", align:"center" },
            ],
            list: [],
            keyword: "",
            page: 1,
            total: 0,
            showAdd: false,
            showEdit: false,
            addForm: {
                name: "",
            },
            editForm: {
                name: ""
            },
            rules: {
                name: [
                    { required: "true", message: "請輸入產品分類名稱", trigger: "blur" }
                ]
            },
            load: false,
            keyword: "",
            tableLoad: false,
        }
    },
    watch: {
        showAdd () { this.load = false },
        showEdit () { this.load = false },
    },
    computed: {
        role () { return this.$store.state.role },
        offset () { return this.$store.state.offset },
    },
    created () {
        if (this.role == 2) {
            this.columns.pop()
        }
        this.showTable()
    },
    methods:{
        search () {
            this.page = 1
            this.showTable()
        },
        showTable () {
            this.tableLoad = true
            this.$axios({
                url: "admin/category",
                params: {
                    page: this.page,
                    offset: this.offset,
                    search: this.keyword
                }
            }).then(res => {
                console.log(res)
                this.tableLoad = false
                if (res.data.data) {
                    this.list = res.data.data
                    this.total = res.data.count
                    if (res.data.data.length == 0 && this.page > 1) {
                        this.page--
                        this.showTable()
                    }
                } else {
                    this.list = []
                    this.total = 0
                }
            }).catch(e => {
                console.log(e)
                this.tableLoad = false
                this.$Message.error("網絡錯誤, 請稍後再試")
            })
        },
        changePage (e) {
            this.page = e
            this.showTable()
        },
        okAdd () {
            let that =this
            this.$refs.addForm.validate(flag => {
                if (flag) {
                    that.load = true
                    that.$axios({
                        url: "admin/category",
                        method:"POST",
                        data: {
                            name: that.addForm.name
                        }
                    }).then(res => {
                        that.load = false
                        if (res.data.code == 200) {
                            that.$Message.success("創建成功")
                            that.showTable()
                            that.showAdd = false
                            that.$refs.addForm.resetFields()
                        } else {
                            that.$Message.warning(res.data.data.msg)
                        }
                    }).catch(e => {
                        console.log(e)  
                        that.load = false
                        that.$Message.error("網絡錯誤, 請稍後再試")
                    })
                }
            })
        },
        okEdit () {
            let that =this
            this.$refs.editForm.validate(flag => {
                if (flag) {
                    console.log(flag)
                    that.load = true
                    that.$axios({
                        url: "admin/category",
                        method:"PUT",
                        data: {
                            uuid: that.editForm.uuid,
                            name: that.editForm.name
                        }
                    }).then(res => {
                        that.load = false
                        if (res.data.code == 200) {
                            that.$Message.success("編輯成功")
                            that.showTable()
                            that.showEdit = false
                        } else {
                            that.$Message.warning(res.data.data.msg)
                        }
                    }).catch(e => {
                        console.log(e)  
                        that.load = false
                        that.$Message.error("網絡錯誤, 請稍後再試")
                    })
                }
            })
        },
        edit (item) {
            this.showEdit = true
            this.editForm.uuid = item.uuid
            this.editForm.name = item.name
        },
        del (item) {
            let that = this
            that.$Modal.confirm({
                title: '提示',
                content : "確定刪除這條信息?",
                onOk () {
                    that.$axios({
                        url: "admin/category",
                        method:"DELETE",
                        data: {
                            uuid: item.uuid
                        }
                    }).then(res => {
                        that.$Message.success('已刪除')
                        that.showTable()
                    })
                }
            })
        }
    }
}
</script>

